// Plural category for the planner's i18n keys (_one / _few / _many): ua by the Ukrainian rules, pl by the Polish ones.
export const pluralForm = (n, language) => {
  const mod10 = n % 10;
  const mod100 = n % 100;
  const few = mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14);
  if (language === 'pl') return n === 1 ? 'one' : few ? 'few' : 'many';
  if (mod10 === 1 && mod100 !== 11) return 'one';
  return few ? 'few' : 'many';
};
